import { DIFFICULTY_LEVEL } from "../../../constants/Constants";
import { useSelector } from "react-redux";
import "../../Style.css";

const BasicConfig = ({ categoryOption, onDurationChange, onChange, interviewTypeOption, onCategoryChange, }) => {
  const { interviewName, duration, categoryName, difficulty, interviewType, } = useSelector(
    (state) => state.interviewconfig
  );
  return (
    <section className="basic-config-section">
      <div className="basic-config-header">
        <div className="basic-config-number-badge">
          1
        </div>
        <h3 className="basic-config-title">
          Basic Configuration
        </h3>
      </div>

      <div className="basic-config-grid">
        <div>
          <label className="basic-config-label">
            Interview Name <span className="basic-config-asterisk">*</span>
          </label>
          <input
            type="text"
            name="interviewName"
            placeholder="Auto-generated or enter custom name..."
            value={interviewName}
            onChange={onChange}
            className="basic-config-input"
          />
        </div>

        <div>
          <label className="basic-config-label">
            Category <span className="basic-config-asterisk">*</span>
          </label>
          <select
            name="categoryName"
            onChange={onCategoryChange}
            value={categoryName || ""}
            className="basic-config-select"
          >
            <option value="" disabled>Choose a Category...</option>
            {categoryOption && categoryOption.length > 0 ? (
              categoryOption.map((category) => (
                <option key={category.id} value={category.value}>
                  {category.value}
                </option>
              ))
            ) : (
              <option value="">Loading categories...</option>
            )}
          </select>
        </div>
      </div>

      <div className="basic-config-grid">
        <div>
          <label className="basic-config-label">
            Duration (minutes) <span className="basic-config-asterisk">*</span>
          </label>
          <input
            type="number"
            min="5"
            max="120"
            name="duration"
            value={duration}
            onChange={onDurationChange}
            className="basic-config-input"
          />
        </div>

        <div>
          <label className="basic-config-label">
            Interview Type <span className="basic-config-asterisk">*</span>
          </label>
          <select
            name="interviewType"
            onChange={onChange}
            value={interviewType || ""}
            disabled={interviewTypeOption?.length === 0}
            className="basic-config-select"
          >
            {interviewTypeOption?.length > 0 ? (
              interviewTypeOption.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.value}
                </option>
              ))
            ) : (
              <option value="">No interview types available</option>
            )}
          </select>
        </div>

        <div>
          <label className="basic-config-label">
            Difficulty Level <span className="basic-config-asterisk">*</span>
          </label>
          <select
            name="difficulty"
            onChange={onChange}
            value={difficulty || "beginner"}
            className="basic-config-select"
          >
            {DIFFICULTY_LEVEL.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    </section>
  );
};

export default BasicConfig;
